import { Theme } from "@mui/material";
import { SxProps } from "@mui/system";

const container: SxProps<Theme> = {
  width: "100vw",
  height: "100vh",
  justifyContent: "center",
  alignItems: "center",
};

export { container };
